import { render, staticRenderFns } from "./ActionHeader.vue?vue&type=template&id=2ed9e1ae&scoped=true&"
import script from "./ActionHeader.vue?vue&type=script&lang=js&"
export * from "./ActionHeader.vue?vue&type=script&lang=js&"
import style0 from "./ActionHeader.vue?vue&type=style&index=0&id=2ed9e1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9e1ae",
  null
  
)

export default component.exports